import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  padding: 10px 0px;
  align-items: center;
`

export const TryAgainButton = styled.div`
  display: flex;
  background-color: #008110;
  color: white;
  padding: 15px 30px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 800;
  border-radius: 3px;
  justify-content: center;
  :hover {
    cursor: pointer;
  }
`
